import React, { FC, useState } from 'react'
import { Iconbtn } from '../../assets/StyledComponent/Input/Input.Style'
import {IoIosArrowUp,IoIosArrowDown} from 'react-icons/io'
interface Iiconbtn{
    icon?:any;
    title:string;
    style?:string;
    handleClick?:any;
    activeModal?:string;
    isDropdown?:boolean;
    props?:any;
}
const Iconbutton:FC<Iiconbtn> = ({title,icon,style,handleClick,activeModal,isDropdown,...props}) => {
  const [isActive,setIsactive]=useState<boolean>(false);
const changeEvent=()=>{
  isDropdown && setIsactive(!isActive)
}
  return (
    <div onClick={()=>changeEvent()}>
       <Iconbtn className={style} onClick={handleClick} data-bs-toggle="modal" data-bs-target={activeModal} >
        <span className=' d-flex align-items-center fs-5'>{icon}</span>
        {title}
        {
          isDropdown &&
        <span style={{marginLeft:'auto',paddingRight:'10px'}}>
          {isActive?<IoIosArrowUp/>:<IoIosArrowDown/>}
        </span>
        }
    </Iconbtn>
    </div>
  )
}

export default Iconbutton